import { render, staticRenderFns } from "./Flash.vue?vue&type=template&id=0a440d5d&scoped=true&lang=pug"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a440d5d",
  null
  
)

export default component.exports